export class Job {
  constructor(
    public id: number,
    public name: string,
    public location: string,
    public open_date: string,
    public open_date_display: string,
    public close_date_display: string,
    public sortable_date: string,
    public unit_name: string,
    public interfolio_position_id: number,
    public legacy_position_id?: number) {
  }
}

interface ISearchItem {
  schoolName: string;
  departmentName: string;
  keyword: string;
}

export class SearchItem implements ISearchItem {
  public schoolName: string;
  public departmentName: string;
  public keyword: string;
  constuctor() {
  }
}

interface ISortItem {
  name: string;
  isAsc: boolean;
}

export class SortItem implements ISortItem {
  public name: string;
  public isAsc: boolean;
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/services/position-services.ts